import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NewEventsInterface } from "interfaces/interfaces-data";
const initialPayload: NewEventsInterface | null = null;

interface AgendaEventState {
  event: NewEventsInterface | null;
}

const agendaDrawerSlice = createSlice({
  name: "agenda-drawer",
  initialState: { drawerOpen: false },
  reducers: {
    toggleDrawer: (state) => {
      state.drawerOpen = !state.drawerOpen;
    },
  },
});

export const { toggleDrawer } = agendaDrawerSlice.actions;
export default agendaDrawerSlice.reducer;
